import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { receiptCustomerRequest } from 'actions/customers/list';
import ReceiptInvoices from 'pages/Reports/Invoices/ReceiptInvoices';
import TransactionDetailReceipt from 'components/receipt/transactions/TransactionDetailReceipt';
import styles from './style.css';
import PurchaseHistory from '../../ListLoyalty/CustomerDetail/PurchaseHistory';
import CustomerHighlight from './CustomerHighlight';
import CustomerInfo from './CustomerInfo';

class CustomerDetail extends React.Component {
  render() {
    const { onClickDone } = this.props;
    const { customerDetail, receiptData } = this.props.data.customers.list;

    return (
      <div className={styles.wrapper}>
        <div
          className={`${
            styles['col-right-inner']
          } customers-list-col-right-inner`}
        >
          <div className={styles['scrolled-area']}>
            <div className="customer-info-box-container" id="customer-detail">
              <CustomerInfo customerDetail={customerDetail} />
              <CustomerHighlight customerDetail={customerDetail} />
              <PurchaseHistory
                customerDetail={customerDetail}
                onClickHistory={this._openReceipt}
                seeMore={this.props.showPurchaseHistory}
              />
            </div>
            {receiptData && receiptData.payment_type === 'invoice' && (
              <div id="receipt-invoice-customer">
                <ReceiptInvoices invoiceDetail={receiptData} />
              </div>
            )}
            {receiptData && receiptData.payment_type !== 'invoice' && (
              <div
                id="receipt-transaction-customer"
                className={styles['receipt-trx-container']}
              >
                <TransactionDetailReceipt paymentDetail={receiptData} />
              </div>
            )}
          </div>
        </div>
        <div className={styles['mk-col-right-action-box-bottom']}>
          <button className="btn btn-primary pull-right" onClick={onClickDone}>
            Done
          </button>
        </div>
      </div>
    );
  }

  _openReceipt = payment => {
    const { customerDetail } = this.props.data.customers.list;
    this.props.dispatch(receiptCustomerRequest(payment, customerDetail));
  };
}

CustomerDetail.propTypes = {
  onClickDone: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    data: {
      customers: {
        list: state.customers.list,
      },
    },
  };
}

export default connect(mapStateToProps)(CustomerDetail);
